<template>
  <card class="card-user">
    <div slot="image">
      <img src="@/assets/img/background.jpg" alt="...">
    </div>
    <div>
      <div class="author">
        <br><br>
        <h4 class="title">{{user.user_name}}
          <br>
          <a href="#">
            <small>{{user.email}}</small>
          </a>
        </h4>
      </div>
      <!-- <p class="description text-center">
        Status: <b>{{user.status}}</b>
        <br>
        Last Login: <b>{{user.last_login_time}}</b>
      </p>
      <p class="text-center">Role: <b>{{user.role_name}}</b></p> -->
    </div>
   
    <hr>
  </card>
</template>
<script>
import API from '../../services/api.js';
export default {
  props: ['user'],
  data() {
    return {
      details: [
        {
          title: "12",
          subTitle: "Files"
        },
        {
          title: "2GB",
          subTitle: "Used"
        },
        {
          title: "24,6$",
          subTitle: "Spent"
        }
      ],
      profile:{}
    };
  },
  created(){
    //this.getProfile()
    console.log(this.user)
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    },
    userLogin() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-lg-3 offset-lg-1";
      } else if (remainder === 2) {
        return "col-lg-4";
      } else {
        return "col-lg-3";
      }
    },
    getProfile(){
       API.get(`/service_client/${this.userLogin.email}`)
          .then(res =>{
            this.profile = res.data
          })
          .catch(error => console.log(error));
    }
  }
};
</script>
<style>
</style>
